var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagnation-nav" },
    [
      _c(
        "nobr",
        { staticClass: "buttons" },
        _vm._l(_vm.getPageCount, function(index) {
          return _c(
            "button",
            {
              key: index,
              class: _vm.getPaginationTabClass(index - 1),
              on: {
                click: function($event) {
                  return _vm.gotoPage(index - 1)
                }
              }
            },
            [_vm._v("\n\n        " + _vm._s(index) + "\n    ")]
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3310a9e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3310a9e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/pagination/Pagination.vue
// module id = null
// module chunks = 